import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './index.css';
import useAuthStore from './store/authStore';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';

// Lazy-ish imports
import DashboardPage from './pages/admin/DashboardPage';
import SeriesPage from './pages/admin/SeriesPage';
import DivisionsPage from './pages/admin/DivisionsPage';
import TeamsPage from './pages/admin/TeamsPage';
import GroundsPage from './pages/admin/GroundsPage';
import AvailabilityPage from './pages/admin/AvailabilityPage';
import ConditionsPage from './pages/admin/ConditionsPage';
import MatrixPage from './pages/admin/MatrixPage';
import SchedulePage from './pages/admin/SchedulePage';
import ScheduleGeneratorPage from './pages/admin/ScheduleGeneratorPage';
import CricClubsPage from './pages/admin/CricClubsPage';
import UsersPage from './pages/admin/UsersPage';
import MyTeamPage from './pages/admin/MyTeamPage';
import PlayoffsPage from './pages/admin/PlayoffsPage';
import GeneratorPage from './pages/admin/GeneratorPage';
import TeamHealthPage from './pages/admin/TeamHealthPage';
import AcceptInvitePage from './pages/AcceptInvitePage';

function ProtectedRoute({ children, roles }) {
  const { user, token } = useAuthStore();
  if (!token || !user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function DashboardRedirect() {
  const { user } = useAuthStore();
  if (user?.role === 'team_user') return <Navigate to="/my-team" replace />;
  return <DashboardPage />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: { background: '#161F35', color: '#E8EDF5', border: '1px solid #1E2D4A', fontFamily: 'Syne, sans-serif', fontSize: 13 },
          success: { iconTheme: { primary: '#00C896', secondary: '#000' } },
          error: { iconTheme: { primary: '#EF4444', secondary: '#fff' } },
        }}
      />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/accept-invite" element={<AcceptInvitePage />} />

        <Route path="/" element={<ProtectedRoute><DashboardRedirect /></ProtectedRoute>} />
        <Route path="/series" element={<ProtectedRoute roles={['admin','scheduler','viewer']}><SeriesPage /></ProtectedRoute>} />
        <Route path="/divisions" element={<ProtectedRoute roles={['admin','scheduler','viewer']}><DivisionsPage /></ProtectedRoute>} />
        <Route path="/teams" element={<ProtectedRoute><TeamsPage /></ProtectedRoute>} />
        <Route path="/grounds" element={<ProtectedRoute roles={['admin','scheduler','viewer']}><GroundsPage /></ProtectedRoute>} />
        <Route path="/availability" element={<ProtectedRoute roles={['admin','scheduler']}><AvailabilityPage /></ProtectedRoute>} />
        <Route path="/conditions" element={<ProtectedRoute roles={['admin','scheduler']}><ConditionsPage /></ProtectedRoute>} />
        <Route path="/matrix" element={<ProtectedRoute roles={['admin','scheduler']}><MatrixPage /></ProtectedRoute>} />
        <Route path="/playoffs" element={<ProtectedRoute roles={['admin','scheduler']}><PlayoffsPage /></ProtectedRoute>} />
        <Route path="/schedule" element={<ProtectedRoute><SchedulePage /></ProtectedRoute>} />
        <Route path="/generator" element={<ProtectedRoute roles={['admin','scheduler']}><GeneratorPage /></ProtectedRoute>} />
        <Route path="/team-health" element={<ProtectedRoute roles={['admin','scheduler','viewer']}><TeamHealthPage /></ProtectedRoute>} />
        <Route path="/schedule/generate" element={<ProtectedRoute roles={['admin','scheduler']}><ScheduleGeneratorPage /></ProtectedRoute>} />
        <Route path="/cricclubs" element={<ProtectedRoute roles={['admin']}><CricClubsPage /></ProtectedRoute>} />
        <Route path="/users" element={<ProtectedRoute roles={['admin']}><UsersPage /></ProtectedRoute>} />
        <Route path="/my-team" element={<ProtectedRoute roles={['team_user']}><MyTeamPage /></ProtectedRoute>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
